// extracted by mini-css-extract-plugin
export var apiV2ChangesInfo = "api-v2-changes-info_PtldsF9qD9a1OOA1FD7n";